import type { FaireProductEntity } from "../../entity_types/product";

export const p_3orx0nk4u5: FaireProductEntity = {
  token: "p_3orx0nk4u5",
  type: "product",
  name: "Canyon Instant Coffee",
  brandToken: "b_50b0t2xt",
  brandName: "Canyon Coffee",
  imageUrl: "https://cdn.faire.com/fastly/d4ddc3d8cd4eae909248a1a351d482424eaf442e3791ebaba064da0fb9246873.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/181775e008563258524bedff46241a99cd6b19557fdaab7e6eca2d1da7044120.jpeg",
    "https://cdn.faire.com/fastly/2634cdbbf2d76d45eb30ecf7c0c9974d49d9ae9512cd739ca77349a0d47ef3e5.jpeg",
    "https://cdn.faire.com/fastly/1cda9c8560fb09d49c68c6b024badd9eb4f35fb7ab0eaab4023be4d4294fba8a.jpeg"
  ],
  priceDollars: 13.5,
  description: "#1 Instant Coffee, According to the New York Times: \"The Best Instant Coffee, Ranked\"\n\nEach Box contains Six Packets. Each packet contains one delicious cup of coffee. Just add 8oz of water and enjoy!\n\n• Medium Roast\n• Origin: Ethiopia\n• Freeze-Dried Coffee\n• Elevation: 1780-1860 Meters\n• Process: Washed\n\n𝐄𝐱𝐩𝐞𝐫𝐢𝐞𝐧𝐜𝐞\nMade from batch-brewed, freshly-roasted coffee from Celinga, Ethiopia, we teamed up with Instant Coffee experts Swift Cup to craft a coffee we love.",
  tags: [],
  msrpDollars: 20,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:33.278Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
